import { Controller } from "@hotwired/stimulus"
import { logEvent } from "../field_logger"

// Logs place-level schedule form submissions to the field diagnostic log.
// Mounted on the place schedule widget form so support can trace when a
// Tasker actually tapped "Save date" for a store visit.
//
// Usage:
//   data-controller="field-place-schedule"
//   data-field-place-schedule-place-id-value="<%= place.id %>"
//   data-field-place-schedule-place-name-value="<%= place.name %>"
export default class extends Controller {
  static values = { placeId: Number, placeName: String }

  connect() {
    this._onSubmit = this._logSubmit.bind(this)
    this.element.addEventListener("turbo:submit-start", this._onSubmit)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this._onSubmit)
  }

  _logSubmit() {
    const form    = this.element.querySelector("form")
    const date    = form?.querySelector("input[type='date']")?.value || null
    const rescheduleAll = form?.querySelector("input[name='schedule_all']")?.checked || false
    const isClearing = form?.submitter?.value === "" || date === ""

    logEvent("schedule", isClearing ? "Place schedule cleared" : "Place visit scheduled", {
      placeId:      this.placeIdValue,
      placeName:    this.placeNameValue,
      date,
      rescheduleAll
    }).catch(() => {})
  }
}
